import React from 'react';
import {NavLink} from "react-router-dom";
import {useModal} from "./Modal";

const Navbar = () => {

    const menuToggle = (e) => {
        const target = document.querySelector('.burger-icon');
        const menu = document.querySelector('.navbar');

        if (target.classList.contains('closed-burger')) {
            target.classList.remove('closed-burger');
            target.classList.add('open-burger');
            menu.classList.remove('opened');
        } else {
            target.classList.remove('open-burger');
            target.classList.add('closed-burger');
            menu.classList.add('opened');
        }
    }

    const { handleShowModal } = useModal();

    return <>
        <header id="header">
            <div className="container">
                <div className="logo">
                    <a href="/">
                        <img src="./images/logo.svg" alt="Rychlý dům" />
                    </a>
                </div>
                <div className="navbar">
                    <ul>
                        <li className="nav-item">
                            <NavLink to="/katalog-domu" onClick={menuToggle} className="nav-link">Katalog domů</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/vybaveni-domu" onClick={menuToggle} className="nav-link">Vybavení domů</NavLink>
                        </li>
                        {/*<li className="nav-item">
                            <NavLink to="/pudorys-domu" onClick={menuToggle} className="nav-link">Půdorys domu</NavLink>
                        </li>*/}
                        <li className="nav-item">
                            <NavLink to="/specifikace-stavby" onClick={menuToggle} className="nav-link">Specifikace stavby</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/galerie" onClick={menuToggle} className="nav-link">Galerie</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/kontakt" onClick={menuToggle} className="nav-link">Kontakt</NavLink>
                        </li>
                    </ul>
                </div>
                <button onClick={handleShowModal} className="bttn inquiry">Mám zájem</button>
                <div className="burger-icon" onClick={menuToggle}>
                    <span className="burger-bun-top"></span>
                    <span className="burger-middle"></span>
                    <span className="burger-bun-bottom"></span>
                </div>
            </div>
        </header>
    </>
}

export default Navbar;